import type { MutableRefObject } from "react";
import { useLayoutEffect, useRef } from "react";

/**
 * @title useLatest
 * @returns ref object
 */
export type UseLatest = <T>(
  /**
   * tracked value
   */
  value: T
) => MutableRefObject<T>;

export const useLatest: UseLatest = <T>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
};
